import { IMicrofrontendsAPI } from '../../../shared/types/microfrontends';
import { openAuthModal, updateHeader } from '../../repositories/header-frontend';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
      updateHeader,
    },
  };
}
